import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		await callback();
	} catch (e) {
		throw e.response.data;
	}
}

function fields() {
	return {
		target: '',
		nickname: '',
		reply_email: '',
		subject: '',
		content: '',
		auto_send_time: Date.now(),
		test_email: ''
	};
}

const Instance = {
	namespaced: true,
	state: {
		targetList: [
			// { value: 0, label: '尚未得到故事帳號' },
			{ value: 1, label: '尚未完成步驟一（成立小組）' },
			{ value: 2, label: '尚未完成步驟二（感受問題）' },
			{ value: 3, label: '尚未完成步驟三（上傳內容）' },
			{ value: 31, label: '尚未完成步驟三也未報名分享季' },
			{ value: 4, label: '尚未完成步驟四（填寫問卷或送出）' },
			{ value: 5, label: '完成挑戰' },
			{ value: 6, label: '已退件' },
			{ value: 7, label: '所有會員' },
		],
		statusList: [
			{ value: 1, label: '草稿' },
			{ value: 2, label: '排程中' },
			{ value: 3, label: '已發送' }
		],
		dataList: [],
		ruleForm: fields(),
		rules: {
			target: [{ required: true, message: '發送對象', trigger: 'blur' }],
			nickname: [{ required: true, message: '別名', trigger: 'blur' }],
			reply_email: [{ required: true, message: '回覆Email', trigger: 'blur' }, { type: 'email', message: '格式必須為email', trigger: 'blur' }],
			subject: [{ required: true, message: '主旨', trigger: 'blur' }],
			content: [{ required: true, message: '內容', trigger: 'blur' }],
			auto_send_time: [{ required: true, message: '發送排程', trigger: 'blur' }]
		}
	},
	mutations: {},
	actions: {
		resetForm({ state }) {
			state.ruleForm = fields();
		},
		async getNotificationList({ state }) {
			await HandleError(async () => {
				state.dataList = (await API.getNotificationList()).data;
			});
		},
		async getNotification({ state }, id) {
			await HandleError(async () => {
				state.ruleForm = (await API.getNotification(id)).data;
			});
		},
		async createNotification({ state }, data) {
			await HandleError(async () => {
				state.dataList = (await API.createNotification(data)).data;
			});
		},
		async updateNotification({ state }, data) {
			await HandleError(async () => {
				state.dataList = (await API.updateNotification(data.id, data)).data;
			});
		},
		async deleteNotification({ state }, id) {
			await HandleError(async () => {
				state.dataList = (await API.deleteNotification(id)).data;
			});
		},
		async testNotification({ state }, data) {
			await HandleError(async () => {
				await API.testNotification(data);
			});
		}
	}
};

export default Instance;